import React, { Fragment, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';


// Components

import PageHeader from '../headers/PageHeader';
import FamilyAndHouseholdSummary_NV from './pageIncludes/summary/FamilyAndHouseholdSummary_NV';

// ActionCreators

import { fetchAllBloodRelationships, fetchTribes } from '@actions/ssap/ssapActionCreators';

// Selectors

import {
    selectAddressVisibilityDueToGeneralDelivery,
    useExchangeAndProgramNames,
    selectIfSogiFeatureEnabled
} from '@reducers/appReducer';



/**
 *
 * @param {Object} props
 * @returns {React.Component} - Summary page for 'Family and Household' Section
 *
 */
const Page2_14  = props => {

    const { householdMembers } = props;

    const {
        allStatuses,
        buttonContainer,
        data: {
            applyingForFinancialAssistanceIndicator,
        },
        environment: {
            isState,
            localDates: {
                serverDate
            }
        },
        militaryActiveDutyReturnQuestionEnabled,
        relations,
        relations: {
            loadedRelationsWholeList = []
        },
        taxHousehold,
        flow: {
            flowType
        },
        stateCode,
        tribes
    } = props;

    // Props from PagesContainer
    const {
        medicaidTerminationFeatureEnabled
    } = props;

    const exchangeAndProgramNames = useExchangeAndProgramNames();
    const addressVisibilityDueToGeneralDelivery = useSelector(selectAddressVisibilityDueToGeneralDelivery);
    const isSogiFeatureEnabled = useSelector(selectIfSogiFeatureEnabled);

    useEffect(() => {
        tribes.length === 0 && props.actions.fetchTribes();
        loadedRelationsWholeList.length === 0 && props.actions.fetchAllBloodRelationships();
    }, []);

    return (
        <Fragment>
            <div id="fhSummary" className="fade-in ">
                <div className="subsection">
                    <PageHeader
                        text='ssap.subheader.review_and_confirm'
                        headerClassName={'gi-heading-alt'}
                    />
                    <div className="grid-row">
                        <div className="usa-alert gi-alert gi-alert__left-accent gi-alert__info alert__review">
                            <div className="gi-alert__body">
                                <p className="gi-alert__text">
                                    <FormattedMessage
                                        id='ssap.family_household.summary.notification'
                                        values={{
                                            strong: function (chunks) {
                                                return <strong>{chunks}</strong>;
                                            },
                                        }}
                                    />
                                </p>
                            </div>
                        </div>
                    </div>
                    <div  className="grid-row">
                        <FamilyAndHouseholdSummary_NV
                            {...{
                                addressVisibilityDueToGeneralDelivery,
                                allStatuses,
                                applyingForFinancialAssistanceIndicator,
                                buttonContainer,
                                exchangeAndProgramNames,
                                flowType,
                                householdMembers,
                                hiddenSummaryItems: ['addressDiff'],
                                isSogiFeatureEnabled,
                                isState,
                                medicaidTerminationFeatureEnabled,
                                militaryActiveDutyReturnQuestionEnabled,
                                relations,
                                serverDate,
                                stateCode,
                                taxHousehold,
                                tribes
                            }}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,
    environment: state.common.environment,
    flow: state.ssap.flow,
    relations: state.ssap.relations,
    householdMembers: state
        .ssap
        .data
        .taxHousehold
        .householdMember,
    taxHousehold: state
        .ssap
        .data
        .taxHousehold,

    stateCode: state
        .common
        .environment
        .stateCode,

    tribes: state.ssap.tribes
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchAllBloodRelationships,
        fetchTribes
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page2_14);
